import React, { useEffect, useState } from 'react'
import { colors, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import { Add, Edit } from '@mui/icons-material';

import FormikControl from '../../../../../components/FormikControl/FormikControl';
import productServices from '../productServices';
import { useAlert } from '../../../../../context/AlertContext';
import { useAppData } from '../../../../../context/AppDataContext';


function ProductForm({data,callBack,callBackWithId }) {

    const {AppAlert} = useAlert();
    const {masters} = useAppData();
    const [formValues, setFormValues] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);

    const initialValues = {
        title:"",
        details:"",
        sku:"",
        brandId:"",
        model:"",
        categoryId:"",
        color:"",
        uom:"",
        billingType:"",
        inventoryType:"",
        expenseType:"",
        gstRate:"",
        hsn:"",
        cost:"",
        price:"",
        mrp:"",
        
    }

    const updateData = ()=>{
        let autoFill = {
            id:data.id,
            title:data.title,
            details:data.details,
            sku:data.sku,
            brandId:data.brandId,
            model:data.model,
            categoryId:data.categoryId,
            color:data.color,
            uom:data.uom,
            billingType:data.billingType,
            inventoryType:data.inventoryType,
            expenseType:data.expenseType,
            gstRate:data.gstRate,
            hsn:data.hsn,
            cost:data.cost,
            price:data.price,
            mrp:data.mrp,
            
        }
        setFormValues(autoFill);
        setDialogStatus(true)
    }

    const validationRule = Yup.object({
        title:Yup.string().required("Required"),
        brandId:Yup.string().required("Required"),        
        //model:Yup.string().required("Required"),
        categoryId:Yup.string().required("Required"),
        uom:Yup.string().required(),
        gstRate:Yup.string().required(),
        billingType:Yup.string().required(),
        expenseType:Yup.string().required(),
        inventoryType:Yup.string().required(),
        hsn:Yup.string().required(),
        gstRate:Yup.string().required(),
        cost:Yup.string().required(),
        price:Yup.string().required(),
        mrp:Yup.string().required(),
    });

    const addNew = ()=>{
        setFormValues(initialValues);
        setDialogStatus(true)
    }

    const handleClose  = () =>{
        setDialogStatus(false);
    }

    const onSubmit = (values, onSubmitProps) => {
        productServices.save(values).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            if(callBackWithId){
                callBackWithId(res.id);
            } else {
                callBack();
            }
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }

    return (
        <>
            {!data &&
                <Tooltip title="Add New">
                    <button type="button" className="btn btn-primary" onClick={addNew} ><Add/> Add New Product</button>
                </Tooltip>
            }
            {data &&
                <Tooltip title="Update">
                    <IconButton onClick={updateData} style={{padding:"0px"}}>
                        <Edit/>
                    </IconButton>
                </Tooltip>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="lg"
                aria-describedby="alert-dialog-slide-description"
            >

                <Formik
                    initialValues={formValues || initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => {
                            //console.log(formik.values);
                            return (
                                <Form>
                                    <DialogTitle>{"Add New Product"}</DialogTitle>
                                    <DialogContent>
                                            <div className="row p-3">
                                                <div className='col-md-6 my-2'>
                                                    <FormikControl control="autoselect" formik={formik} 
                                                        label="Product Category" name="categoryId"  
                                                        options={masters['product-category']} multiple={false} 
                                                    />
                                                </div>

                                                <div className="col-md-6 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="Product Name" name="title" 
                                                    />
                                                </div>

                                                
                                                <div className="col-md-12 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" multiline={true}
                                                        label="Description" name="details"   
                                                    />
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <hr/>
                                                <div className="col-md-3 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="SKU" name="sku" 
                                                        
                                                    />
                                                </div>
                                                <div className="col-md-3 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="Color" name="color"   
                                                    />
                                                </div>

                                                <div className='col-md-3 my-2'>
                                                    <FormikControl control="autoselect" formik={formik} 
                                                        label="Product Brand" name="brandId"  
                                                        options={masters['product-brand']} multiple={false} 
                                                    />
                                                </div>

                                                <div className="col-md-3 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="Model" name="model"   
                                                    />
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <hr/>
                                                <div className="col-md-3 my-2" >
                                                    <FormikControl control="autoselect" formik={formik} 
                                                        label="UOM" name="uom"  
                                                        options={masters['product-uom']} multiple={false} 
                                                    />
                                                </div>

                                                <div className="col-md-3 my-2" >
                                                    <FormikControl control="autoselect" formik={formik} 
                                                        label="Billing Type" name="billingType"  
                                                        options={masters['billing-type']} multiple={false} 
                                                    />
                                                </div>

                                                <div className="col-md-3 my-2" >
                                                    <FormikControl control="autoselect" formik={formik} 
                                                        label="Inventory Type" name="inventoryType"  
                                                        options={masters['inventory-type']} multiple={false} 
                                                    />
                                                </div>
                                                
                                                <div className="col-md-3 my-2" >
                                                    <FormikControl control="autoselect" formik={formik} 
                                                        label="Expense Type" name="expenseType"  
                                                        options={masters['expense-type']} multiple={false} 
                                                    />
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <hr/>
                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="HSN Code" name="hsn"   
                                                    />
                                                </div>

                                                <div className="col-md-2 my-2" >
                                                    <FormikControl control="input" formik={formik} type="number"
                                                        label="GST Rate" name="gstRate"   
                                                    />
                                                </div>

                                                <div className="col-md-2 my-2" >
                                                    <FormikControl control="input" formik={formik} type="number"
                                                        label="Cost" name="cost"   
                                                    />
                                                </div>

                                                <div className="col-md-2 my-2" >
                                                    <FormikControl control="input" formik={formik} type="number"
                                                        label="Selling Price" name="price"   
                                                    />
                                                </div>

                                                <div className="col-md-2 my-2" >
                                                    <FormikControl control="input" formik={formik} type="number"
                                                        label="MRP" name="mrp"   
                                                    />
                                                </div>

                                            </div>
                                           
                                        <div className="row mt-3">
                                            <div className='col-md-12'>
                                                {savingInProgress ?
                                                    <LinearProgress/>
                                                    :
                                                    <>
                                                        <button className="btn btn-primary float-end" type="submit">Save</button>
                                                        <button className="btn btn-outline-primary" type="button" onClick={handleClose}>Cancel</button>
                                                    </>
                                                }
                                            </div>
                                            <div className='col-md-12'>
                                                { /* JSON.stringify(formik.values)  */}
                                            </div>
                                        </div>
                                    </DialogContent>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Dialog>

        </>
    )
}

export default ProductForm